import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names with conflict resolution.
 *
 * `clsx` handles conditional + array inputs; `twMerge` dedupes conflicting
 * Tailwind utilities (e.g. `px-2 px-4` → `px-4`). This is the single helper
 * used across the component library.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
